module.exports = __webpack_public_path__ + "img/fa-solid-900.7a5de9b0.svg";